/**
 * Router.
 *
 * @module app/controllers/HashListener
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';

/**
 * Event handler for DOM Ready
 *
 * @returns {void}
 *
 * @private
 */
var onDOMReady = function onDOMReady() {

    jQuery(window).off('hashchange', publishHash);
    jQuery(window).on('hashchange', publishHash);

    //initial hash publish
    if (location.hash !== '') {
        publishHash();
    }
 
};


/**
 * Notifies the Hash changes through messageBus
 *
 * @returns {void}
 *
 * @private
 */
var publishHash = function publishHash() {

    window.WH.messageBus.publish(
        MessageBusTopics.APP_JS_HASH_CHANGE,
        { hash: location.hash.toString().replace(/^#/, '') }
    );
};

/**
 * Flat object to contain public methods
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Starts the hash listener
     *
     * @returns {void}
     *
     * @private
     */
    start: function () {

        window.WH.messageBus.subscribe(MessageBusTopics.APP_JS_DOM_READY, onDOMReady);
    },
};

export default api;
